import { render, staticRenderFns } from "./StoriesPost.vue?vue&type=template&id=9d3613ba"
import script from "./StoriesPost.vue?vue&type=script&lang=js"
export * from "./StoriesPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports